import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(main)/error.tsx");
